import { WorkflowContext } from '@samelogic/steps';
import { screen } from '@testing-library/dom';
import userEvent from '@testing-library/user-event';

import { contextFactory } from '../../../__tests__/factories';
import { ElementEvent, ElementEventStrategy, ElementEventProps } from './ElementEventStrategy';
import { OnEventTriggered, OnEventTriggeredEvent } from './EventStrategy';

describe('ElementEvent', () => {
  const cssClass = 'some-selector';
  let elementEventStrategy: ElementEventStrategy;
  const onTriggerEventMock = jest.fn<
    OnEventTriggered<ElementEventProps, ElementEvent>,
    [OnEventTriggeredEvent<ElementEventProps, ElementEvent>]
  >();
  beforeEach(() => {
    document.body.innerHTML = ``;
  });

  describe('css selector exists', () => {
    const context: WorkflowContext = contextFactory.build();
    beforeEach(() => {
      document.body.innerHTML = `
      <button class='${cssClass}'>some button</button>
      `;
    });
    describe('click event', () => {
      const props: ElementEventProps = {
        cssSelector: `.${cssClass}`,
        event: 'ElementClick'
      };
      beforeEach(() => {
        elementEventStrategy = new ElementEventStrategy(context, props);
        elementEventStrategy.start();
        elementEventStrategy.onEventTriggered = onTriggerEventMock;
      });
      it('should fire the onEventTriggered event', () => {
        userEvent.click(screen.getByRole('button'));
        expect(onTriggerEventMock).toBeCalledWith(
          expect.objectContaining({
            condition: true
          })
        );
      });
    });

    describe('mouseover event', () => {
      const props: ElementEventProps = {
        cssSelector: `.${cssClass}`,
        event: 'ElementMouseOver'
      };
      beforeEach(() => {
        elementEventStrategy = new ElementEventStrategy(context, props);
        elementEventStrategy.start();
        elementEventStrategy.onEventTriggered = onTriggerEventMock;
      });
      it('should fire the onEventTriggered event', () => {
        userEvent.hover(screen.getByRole('button'));
        expect(onTriggerEventMock).toBeCalledWith(
          expect.objectContaining({
            condition: true,
            props: props
          })
        );
      });
    });
  });

  describe('when css selector exist on element with default behavior', () => {
    const context = contextFactory.build();
    beforeEach(() => {
      document.body.innerHTML = `
      <a href='https://google.com' class='${cssClass}'>some button</a>
      `;
    });
    describe('when event is fired when delayDefaultBehavior is true', () => {
      const props: ElementEventProps = {
        cssSelector: `.${cssClass}`,
        event: 'ElementClick',
        delayDefaultBehavior: true
      };
      beforeEach(() => {
        elementEventStrategy = new ElementEventStrategy(context, props);
        elementEventStrategy.start();
        elementEventStrategy.onEventTriggered = onTriggerEventMock;
      });
      it('should fire the onEventTriggered event', () => {
        userEvent.click(screen.getByRole('link'));
        expect(onTriggerEventMock).toBeCalledWith(
          expect.objectContaining({
            condition: true
          })
        );
      });
      // it('should disable the default behavior', () => {});

      // describe('when workflow is completed', () => {
      //   beforeEach(() => {
      //     context.Completed('completed');
      //   });
      //   it('should resume the default behavior', () => {});
      // });
    });
  });
});
